module.exports = __webpack_public_path__ + "img/m_and_m_meat_shops.992c08c0.jpg";